import { useMemo } from 'react';
import container from 'src/container';
import useSWR from 'swr';
import { useSignedInUser } from '../useSignedInUser';
import {
    getOrganizationId,
    // UserRole,
    // getPrimaryRole,
} from 'src/domain/user';

const {
    cradle: { munduClient },
} = container;

export const useCreators = () => {
    const user = useSignedInUser();
    // const role = getPrimaryRole(user);

    const organizationId = useMemo(() => {
        if (!user) {
            return;
        }
        return getOrganizationId(user);
    }, [user]);

    const swrKey = organizationId
        ? [
              'creators/organizationId',
              organizationId,
              // role === UserRole.creator ? user?.id : 'all',
          ]
        : null;

    const { data, error, mutate } = useSWR(swrKey, () =>
        munduClient.listCreators({
            organizationId,
            // ...(role === UserRole.creator ? { creatorId: user?.id } : {}),
        }),
    );

    return {
        creators: data || [],
        mutate: mutate,
        isLoading: !error && !data,
        isError: error,
    };
};

export const useConsumersFollowers = (consumerId: string) => {
    const user = useSignedInUser();
    const organizationId = user ? getOrganizationId(user) : undefined;

    return useSWR(
        [consumerId, organizationId, 'creators/consumerId'],
        () => munduClient.listCreators({ consumerId, organizationId }),
        {
            revalidateOnFocus: false,
        },
    );
};

export const useCreator = (creatorId: string) => {
    return useSWR([creatorId, 'creators/creatorId'], () =>
        munduClient.getCreator(creatorId),
    );
};
